import React from "react";
import {
  Accordion,
  DoubleContent,
  Headline,
  LinkPrimary,
  SectionContent,
  TextBodyAccordion,
} from "../../../../components";
import { links } from "../../../../config";

const DFIAccordion = [
  {
    title: "Sobre o seguro DFI",
    body: (
      <TextBodyAccordion>
        Quem adquire um imóvel, constrói ou reforma com o consórcio imobiliário,
        conta com o seguro de Danos Físicos ao Imóvel - DFI. Esse seguro só é
        cobrado após a utilização do crédito e oferece algumas coberturas como:
        incêndio, queda de raio e explosão, desmoronamento total ou parcial.
      </TextBodyAccordion>
    ),
  },
  {
    title: "Riscos excluídos",
    body: (
      <TextBodyAccordion>
        <LinkPrimary target="_blank" href={links.consorcio.riscosExcluidos}>
          Consulte os riscos excluídos
        </LinkPrimary>{" "}
        do Seguro Prestamista para consórcios adquiridos a partir de 18/02/2010.
      </TextBodyAccordion>
    ),
  },
];

const SeguroDFI = () => {
  return (
    <>
      <SectionContent>
        <DoubleContent
          leftContent={
            <Headline nivel="2" styleAs="5" leadMobile>
              Seguro de danos físicos ao imóvel (DFI)
            </Headline>
          }
          rightContent={<Accordion listItems={DFIAccordion} />}
        />
      </SectionContent>
    </>
  );
};

export default SeguroDFI;
